var _module = require('../components/module.js');

require('angular-sanitize');

_module.requires.push(
    'ngSanitize'
);

_module.filter('html', [
    '$sce',

    function ($sce) {
        return function (str) {
            return $sce.trustAsHtml(str);
        };
    }
]);
